import { HeaderProvider } from '../../hooks/header';
import { ModalProvider } from 'react-modal-hook';
import { NavigatorProvider } from '../../hooks/navigator';
import { SidebarProvider } from '../../hooks/sidebar';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        minHeight: '100vh',
    },
    appContent: {
        flex: 1,
        minWidth: 0,
        display: 'flex',
        flexDirection: 'column',
    },
}));
// Must be used inside a Router & Theme Provider to work correctly.
export const AppShell = (props) => {
    const { isNavigatorVisible = true, logoUrl, navigatorItems, navigatorAfterItems, navigatorDefaultOpenOnDesktop, navigatorHeader, navigatorFooter, appTitle, children, ...rest } = props;
    const classes = useStyles();
    return (React.createElement(ModalProvider, null,
        React.createElement("div", { className: classes.root },
            React.createElement(NavigatorProvider, { isNavigatorVisible: isNavigatorVisible, navigatorItems: navigatorItems, appTitle: appTitle, navigatorAfterItems: navigatorAfterItems, navigatorDefaultOpenOnDesktop: navigatorDefaultOpenOnDesktop, logoUrl: logoUrl, navigatorFooter: navigatorFooter, navigatorHeader: navigatorHeader },
                React.createElement("main", { className: classes.appContent },
                    React.createElement(HeaderProvider, Object.assign({ logoUrl: logoUrl, isNavigatorVisible: isNavigatorVisible }, rest),
                        React.createElement(SidebarProvider, null, children)))))));
};
//# sourceMappingURL=AppShell.js.map